import {
  ErrorHandler,
  inject,
  mergeApplicationConfig,
  provideAppInitializer,
} from '@angular/core';
import { TraceService, createErrorHandler } from '@sentry/angular';
import { APP_BASE_CONFIG } from './app.base.config';

export const APP_BROWSER_CONFIG = mergeApplicationConfig(APP_BASE_CONFIG, {
  providers: [
    {
      provide: ErrorHandler,
      useValue: createErrorHandler({
        showDialog: false,
      }),
    },
    TraceService,
    provideAppInitializer(() => {
      // Starts Sentry navigation spans.
      inject(TraceService);
    }),
  ],
});
